import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { HomePageComponent, KwikstoreVisualEditorComponent, PreviewComponent, PreviewEditStoreService,ResponsivePreviewComponent } from '@urbannex/kwikstore-visual-editor';
import { provideAnimations } from '@angular/platform-browser/animations';
import { KwikHubComponent } from './kwik-hub/kwik-hub.component';
import { AdminComponent } from './admin/admin.component';
import { UserData } from 'src/app/@core/data/users';
import { UserService } from 'src/app/@core/mock/users.service';
import { ConfigurationService } from '@urbannex/configuration';
import { ProductStoreComponent } from './product-store/product-store.component';
import { StoresComponent } from '@urbannex/pms';
import { ViewContainersService } from '@urbannex/view-containers';
import { RecommendationChatComponent } from '@urbannex/recommender-chat';

export const routes:Routes = [
  {
    path:'',
    component:KwikHubComponent
  },
  {
    path:'kve',
    loadChildren: () => import('@urbannex/kwikstore-visual-editor')
    .then(m => m.KwikstoreVisualEditorModule)
  },
  {
    path:'admin',
    component:AdminComponent,
    providers:[
      UserService,ConfigurationService,
      { provide: UserData, useClass: UserService }
    ],
    children:[
      {
        path: '',
        redirectTo: 'pms',
        pathMatch: 'full'
      },
      {
        path:'stores',
        loadChildren: () => import('@urbannex/pms')
        .then(m => m.StoresModule)
      },
      {
        path:'products',
        loadChildren: () => import('@urbannex/pms')
        .then(m => m.ProductsModule)
      },
      {
        path:'catalogs',
        loadChildren: () => import('@urbannex/pms')
        .then(m => m.CatalogModule)
      },
      {
        path:'categories',
        loadChildren: () => import('@urbannex/pms')
        .then(m => m.CategoriesModule)
      },
      {
        path:'configurations',
        loadChildren: () => import('@urbannex/pms')
        .then(m => m.ConfigurationsModule)
      },
      {
        path:'orders',
        loadChildren: () => import('@urbannex/pms')
        .then(m => m.OrdersModule)
      },
      {
        path:'features',
        loadChildren: () => import('@urbannex/pms')
        .then(m => m.FeaturesModule)
      },
      {
        path:'facilities',
        loadChildren: () => import('@urbannex/pms')
        .then(m => m.FacilitiesModule)
      },
      {
        path:'img',
        loadChildren:() => import('@urbannex/pms')
        .then(m => m.ImageManagementModule)
      },
      {
        path:'product-store',
        component:ProductStoreComponent
      },
      {
        path:'pms',
        loadChildren: () => import('@urbannex/pms')
        .then(m => m.PmsModule)
      },
      {
        path:'marketing',
        loadChildren: () => import('@urbannex/pms')
        .then(m => m.MarketingModule)
      },
      {
        path:'cms',
        loadChildren:() => import('@urbannex/cms')
        .then(m => m.CmsModule)
      },
      {
        path:'blog',
        providers:[ConfigurationService],
        loadChildren:() => import('@urbannex/blog')
        .then(m => m.UbsBlogModule)
      },
      {
        path:'shipping',
        loadChildren:() => import('@urbannex/pms')
        .then(m =>m.ShippingModule)
      },
      {
        path:'crm',
        loadChildren:() => import('@urbannex/partymgr')
        .then(m => m.PartymgrModule)
      }
      
    ]
  },
  /* {
    path:'admin',
    loadComponent: () => import('./admin/admin.component').then((m) => m.AdminComponent),
    children:[
      {
        path:'pms',
        loadChildren: () => import('@urbannex/pms')
        .then(m => m.PmsModule)
      }
    ]
  }, */
  {
    path:'ai',
    component:RecommendationChatComponent
  },
  {
    path:'pms',
    loadChildren: () => import('@urbannex/pms')
    .then(m => m.PmsModule)
  },
  {
    path:'preview',
    component:PreviewComponent,
    providers: [ 
      PreviewEditStoreService,provideAnimations()
    ]
  },
  {
    path:'responsive',
    component:ResponsivePreviewComponent
  },
  { path: '', redirectTo: 'kve', pathMatch: 'full' },
  { path: '**', redirectTo: 'kve' },
]
const config: ExtraOptions = {
  useHash: false,
};
@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forRoot(routes, config)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
